import React from 'react';
import { useTransform, useViewportScroll, useSpring } from 'framer-motion';

// LTR = Left to right
// RTL = Right to Left
// BTT = Bottom to top
export const animationTypes = { VERTICLE: 'verticle', HORIZONTAL: 'horizontal' };
export const SlideInWithScroll = ({ elementTop, clientHeight, triggerPoints, children, direction = "LTR", length = 50, opacityChange = true, positionChange = true, sizeChange = false }) => {
  const { scrollY } = useViewportScroll();
  const easing = [0.42, 0, 0.58, 1];
  const getScrollValue = (trigger) => {
    return elementTop - clientHeight * trigger;
  };
  const springConfig = {
    damping: 40,
    stiffness: 500
  };
  let yL = useTransform(scrollY, [getScrollValue(triggerPoints[0]), getScrollValue(triggerPoints[1])], [0 - length, 0], easing);
  let yR = useTransform(scrollY, [getScrollValue(triggerPoints[0]), getScrollValue(triggerPoints[1])], [length, 0], easing);
  let y = useTransform(scrollY, [getScrollValue(triggerPoints[0]), getScrollValue(triggerPoints[1])], [length, 0], easing);
  const opacity = useTransform(scrollY, [getScrollValue(triggerPoints[0]), getScrollValue(triggerPoints[1])], [0, 1], easing);

  let style = {};
  if (direction === "LTR" && opacityChange && positionChange) {
    style = { x: yL, opacity };
  } else if (direction === "RTL" && opacityChange && positionChange) {
    style = { x: yR, opacity };
  } else if (direction === "BTT" && opacityChange && positionChange) {
    style = { y, opacity };
  } else if (opacityChange && !positionChange) {
    style = { opacity };
  } else if (sizeChange && !opacityChange && !positionChange) {
    style = { scale: opacity };
  }

  if (!elementTop) {
    //console.log('error fetching element top');
    style = {};
  }

  return React.cloneElement(children, { style });
};